<template lang="pug">
  .waybill.waybill-groups
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :hideAddButton="true"
      :showExport="true"
      :showViewPanel="false"
      :hideImportBtn="true"
      :endpointExport="getEndpointExport()"
    )
      div(slot="filter-status" v-if='hasWaybillFilters')
        filters(
          @changeFilter='changeFilter'
        )
    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="editItem"
      :showCheckbox="false"
      :actionColumnWidth="100"
    )
    router-view
</template>

<script>
import { transport, export_document } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'
import permissionMixin from '@/mixins/permission-mixin'
import url from '@/utils/url'
import routeMixin from '@/mixins/route-mixin'
import hasMixin from '@/mixins/has-mixin'
import Filters from './components/filters'

export default {
  components: { Filters },
  mixins: [tableMixin, permissionMixin, routeMixin, hasMixin],
  watch: {
    $route: 'onRoute',
  },
  methods: {
    onRoute(oldValue, newValue) {
      if (newValue.query.q) {
        this.reFetchData()
      }
    },

    reFetchData() {
      this.$bar.start()
      this.$store
        .dispatch('updateUrlEndpoint', {
          endpoint: this.getEndpoint(this.$route),
        })
        .finally(() => {
          this.$bar.finish()
        })
    },
    getEndpoint(route) {
      return transport.waybills(route)
    },
    editItem(item) {
      this.$router.push({
        name: 'waybill.waybills.update',
        params: { id: item.id },
        query: {
          prevRoute: url.getRoute(this.$route, true),
        },
      })
    },
    changeFilter() {
      this.reFetchData()
    },
    getEndpointExport() {
      return export_document.waybills(this.$route)
    },
    getDeleteUrl(id) {
      return transport.waybill(id)
    },
  },
}
</script>
<style lang="scss">
.waybill-groups {
  overflow: hidden;
}
</style>
